<script>
  import _base from '../../_default/components/_base.vue'
  import Service from '../../../domain/relatorios/services/index.js'
  import ImportProgress from '../documentos/components/ImportProgress'
  import RelatorioBasicoResult from './components/Result'
  import {VueMaskDirective as mask} from 'v-mask'
  import {isValidDate} from '../../../utils/helpers/validators'
  import moment from 'moment'
  import RelatorioBasicoMediaComitentes from './components/ResultMediaFipeComitentes'
  import RelatorioBasicoMediaComitentesMinimo from './components/ResultMediaFipeComitentesComMinimo'
  import RelatorioBasicoMediaComitentesMes from './components/ResultMediaFipeComitenteMes'

  let anteriousDate = moment().add(-1, 'month')

  let Meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

  export default {
    name: 'Relatorios',
    extends: _base,
    data () {
      return {
        tipo: 1,
        graphLoaded: false,
        isLoading: false,
        loadPercent: 0,
        data: null,
        data1: null,
        data2: null,
        comitente: null,
        mes1: String(anteriousDate.format('M')),
        ano1: String(anteriousDate.format('YYYY')),
        mes2: String(moment().format('M')),
        ano2: String(moment().format('YYYY')),
        comitentes: null
      }
    },
    created () {
    },
    computed: {
      periodo () {
        if (this.data1 === this.data2) {
          return 'Período: ' + this.data1
        }
        return `Período: ${this.data1} a ${this.data2}`
      },
      meses () {
        return Meses
      },
      periodoMeses () {
        return `Período: ${this.meses[parseInt(this.mes1)]}/${this.ano1} a ${this.meses[parseInt(this.mes2)]}/${this.ano2}`
      },
      comitenteSelecionado () {
        let selecionado = this.comitentes.filter((c) => c.id === this.comitente)
        return selecionado[0]
      }
    },
    watch: {
      'data1' () {
        this.graphLoaded = false
      },
      'data2' () {
        this.graphLoaded = false
      }
    },
    mounted () {
      this._showMenu(false)
      this._showHeader(true)
      this._showFooter(false)
      this._menuFolded(false)
      Service.dataComitentes()
        .then(response => {
          this.comitentes = response.data
        })
      this.$nextTick(() => {
        this.$root.$el.classList.add('full-height')
      })
    },
    destroyed () {
      this.$root.$el.classList.remove('full-height')
    },
    methods: {
      startLoading () {
        this.graphLoaded = false
        this.loadPercent = 0
        this.isLoading = true
        this.$interval = window.setInterval(() => {
          if (this.loadPercent >= 100) {
            window.clearInterval(this.$interval)
            this.loadPercent = 100
          } else {
            this.loadPercent = Math.round(this.loadPercent + (Math.random() + 1))
          }
        }, 50)
      },
      stopLoading () {
        window.clearInterval(this.$interval)
        this.isLoading = false
        this.loadPercent = 100
      },
      mediaFipe () {
        if (!this.validarIntervaloData()) {
          return
        }
        this.startLoading()
        Service.mediaFipe(this.data1, this.data2)
          .then(response => {
            this.stopLoading()
            this.graphLoaded = true
            this.data = response.data
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      mediaFipeComitente () {
        if (!this.validarIntervaloData()) {
          return
        }
        this.startLoading()
        Service.mediaFipeComitente(this.data1, this.data2)
          .then(response => {
            this.stopLoading()
            this.graphLoaded = true
            this.data = response.data
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      mediaFipeComitenteMinimo () {
        if (!this.validarIntervaloData()) {
          return
        }
        this.startLoading()
        Service.mediaFipeComitente(this.data1, this.data2)
          .then(response => {
            this.stopLoading()
            this.graphLoaded = true
            this.data = response.data
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      mediaFipeComitenteMes () {
        if (!this.comitente) {
          alert('Selecione um comitente')
          return
        }
        this.startLoading()
        let data1, data2
        data1 = `01/${String(this.mes1).padStart(2, '0')}/${this.ano1}`
        let lastDay = new Date(this.ano2, this.mes2, 0)
        data2 = `${String(lastDay.getDate()).padStart(2, '0')}/${String(this.mes2).padStart(2, '0')}/${this.ano2}`
        Service.mediaFipeComitenteMes(this.comitente, data1, data2)
          .then(response => {
            this.stopLoading()
            this.graphLoaded = true
            this.data = response.data
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      validarIntervaloData () {
        if (!isValidDate(this.data1, 'pt-br') || !isValidDate(this.data2, 'pt-br')) {
          alert('Digite um intervalo de datas válido')
          return false
        }
        return true
      },
      gerar () {
        if (this.tipo === 1) {
          this.mediaFipe()
        } else if (this.tipo === 2) {
          this.mediaFipeComitente()
        } else if (this.tipo === 3) {
          this.mediaFipeComitenteMinimo()
        } else if (this.tipo === 4) {
          this.mediaFipeComitenteMes()
        } else {
          alert('Selecione um tipo de relatório válido')
        }
      },
      modifyForm () {
        this.graphLoaded = false
      }
    },
    components: {
      RelatorioBasicoMediaComitentes,
      RelatorioBasicoResult,
      ImportProgress,
      RelatorioBasicoMediaComitentesMinimo,
      RelatorioBasicoMediaComitentesMes
    },
    directives: {mask}
  }
</script>

<template>
  <div class="relatorios-basico h-full">
    <div class="header hidden-print">
      <form v-on:submit.prevent="gerar">
        <div class="title"><h1>Relatórios</h1></div>
        <div class="rel-type">
          <select v-model="tipo">
            <option :value="1" selected>Média X Fipe</option>
            <option :value="2">Média X Fipe Comitente</option>
            <option :value="3">Minimo X Fipe Comitente</option>
            <option :value="4">Mensal Média X Fipe Comitente</option>
          </select>
        </div>
        <div class="filters">
          <select v-if="tipo === 4" v-model="comitente" @change="modifyForm" class="m-r">
            <option :value="null">Selecione</option>
            <option v-for="comitente in comitentes" :value="comitente.id">{{comitente.nome}}</option>
          </select>
          <div class="text-white">Período:</div>
          <input v-if="tipo !== 4" v-model="data1" @change="modifyForm" autofocus v-mask="'##/##/####'" class="m-l">
          <input v-if="tipo !== 4" v-model="data2" @change="modifyForm" v-mask="'##/##/####'" class="m-l">

          <!--<input v-if="tipo === 4" v-model="mes1" autofocus v-mask="'##/##/####'" class="m-l">
          <input v-if="tipo === 4" v-model="mes2" v-mask="'##/####'" class="m-l">-->
          <select v-if="tipo === 4" v-model="mes1" @change="modifyForm" class="m-l">
            <option v-for="(mes, key) in meses" :value="key+1">{{mes}}</option>
            <!--<option :value="1">Janeiro</option>
            <option :value="2">Fevereiro</option>
            <option :value="3">Março</option>
            <option :value="4">Abril</option>
            <option :value="5">Maio</option>
            <option :value="6">Junho</option>
            <option :value="7">Julho</option>
            <option :value="8">Agosto</option>
            <option :value="9">Setembro</option>
            <option :value="10">Outubro</option>
            <option :value="11">Novembro</option>
            <option :value="12">Dezembro</option>-->
          </select>

          <select v-if="tipo === 4" v-model="ano1" @change="modifyForm" class="m-l-xs"> <!-- TODO: Adjust automatic years interval -->
            <option :value="2018">2018</option>
            <option :value="2019">2019</option>
          </select>

          <select v-if="tipo === 4" v-model="mes2" class="m-l">
            <option v-for="(mes, key) in meses" :value="key+1">{{mes}}</option>
          </select>

          <select v-if="tipo === 4" v-model="ano2" class="m-l-xs"> <!-- TODO: Adjust automatic years interval -->
            <option :value="2018">2018</option>
            <option :value="2019">2019</option>
          </select>

          <button type="submit" class="m-l btn btn-sm btn-default">Gerar</button>
          <button type="button" class="m-l btn btn-sm btn-dark" @click="$router.push('/')">x Fechar</button>
        </div>
      </form>
    </div>

    <div v-if="graphLoaded && tipo === 1" class="content">

      <relatorio-basico-result :data="data.salvados" type="Salvados" :period="periodo"/>
      <relatorio-basico-result :data="data.sucatas" type="Sucatas" :period="periodo"/>

    </div>

    <div v-if="graphLoaded && tipo === 2" class="content">

      <relatorio-basico-media-comitentes :data="data" :period="periodo"/>

    </div>

    <div v-if="graphLoaded && tipo === 3" class="content">

      <relatorio-basico-media-comitentes-minimo :data="data" :period="periodo"/>

    </div>

    <div v-if="graphLoaded && tipo === 4" class="content">

      <relatorio-basico-media-comitentes-mes :data="data" :period="periodoMeses" :comitente="comitenteSelecionado"/>

    </div>

    <div class="content loading" v-if="isLoading">
      <div class="cload">
        <import-progress :percent="loadPercent"></import-progress>
      </div>
    </div>

    <div class="content loading" v-if="!isLoading && !graphLoaded">
      <div class="cload no-select">
        Selecione um relatório e clique em <strong>Gerar</strong>
      </div>
    </div>

  </div>
</template>

<style lang="scss" src="./assets/scss/default.scss"></style>



// WEBPACK FOOTER //
// Main.vue?b598830e